import { createApp } from 'vue';
// Import libraries
import vue3GoogleLogin from 'vue3-google-login';
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import '@quasar/extras/material-icons/material-icons.css';
import 'quasar/src/css/index.sass';
// Initializers
import registerGlobalComponents from '@/boot/global_components';
import registerMixins from '@/boot/mixin';
import registerQuasar from '@/boot/quasar';
import '@/boot/quasar-colors';
// App configurations
import { i18n } from '@/locales/i18n';
import router from '@/router/router';
import pinia from '@/store';
// Style Sheets
import '@/assets/stylesheets/animate.css';
import '@/assets/stylesheets/app.scss';
import '@/assets/stylesheets/style.css';
// Components
import App from '@/App.vue';

const app = createApp(App);

// Register initializers
registerGlobalComponents(app);
registerMixins(app);
registerQuasar(app);

app
  .use(router)
  .use(pinia)
  .use(i18n)
  .use(vue3GoogleLogin, {
    clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID_KEY as string,
  });
app.mount('#app');
